<template>
  <s-modal :show="open">
    <div class="modal modal_template" v-if="open">
      <div class="modal_template__close" @click="handleClose">
        <x-icon-close />
      </div>
      <div class="modal_template__content">
        <div
          class="modal_template__modalImg"
          :class="{ landscape: isLandscape }"
        >
          <div class="img_contaner">
            <img :src="config.src" :alt="config.name" />
          </div>
        </div>
        <div class="modal_template__modalName">
          {{ config.name }}
        </div>
        <div
          class="modal_template__description"
          v-html="config.description"
        ></div>
        <div class="modal_template__btn">
          <button class="s-button blue-btn close-btn" @click="handleClose">
            閉じる
          </button>
        </div>
      </div>
    </div>
  </s-modal>
</template>

<script>
import { EventBus } from '@/constants/events'

export default {
  data: () => ({
    open: false,
    config: {
      src: null,
      name: null,
      description: null,
    },
  }),
  props: {
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show(config = {}) {
      this.open = true
      this.config = { ...this.config, ...config }
      EventBus.$emit('status-popup', this.visible)
    },
    handleOpen() {
      this.open = true
    },
    handleClose() {
      this.open = false
    },
  },
  mounted() {
    EventBus.$on('open-popup', this.handleOpen)
  },
}
</script>

<style lang="scss" scoped>
@import './modal-shape-info.scss';
</style>
